import PageTypeFactory from '../../../page/get_page_type';
import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';

function improveFilter(filter, improveTo) {
    const category = GA_EVENTS.catalogNoResultSuggestion.category;
    const action = GA_EVENTS.catalogNoResultSuggestion.actions.improveFilter[filter] || filter;

    setBehaviourEvent({ category, action, label: improveTo });
}

function removeFilter(filter) {
    const category = GA_EVENTS.catalogNoResultSuggestion.category;
    const action = GA_EVENTS.catalogNoResultSuggestion.actions.removeFilter[filter] || filter;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

export {
    improveFilter,
    removeFilter
};